import { showSessionToast, sessionExpiredMessage } from './sessionToast';

const GATE_KEY = 'aaz-strapi-401-gate';

let redirectToLogin = (path) => {
    if (typeof window !== 'undefined') window.location.assign(path);
};

export function registerStrapiUnauthorizedRedirect(fn) {
    redirectToLogin = typeof fn === 'function' ? fn : defaultRedirect;
}

function defaultRedirect(path) {
    if (typeof window !== 'undefined') window.location.assign(path);
}

/** Llamar al montar Login para permitir un nuevo intento tras redirección por 401 */
export function clearStrapi401Gate() {
    try {
        sessionStorage.removeItem(GATE_KEY);
    } catch (_) {
        /* ignore */
    }
}

/** Solo sesión JWT Strapi inválida/vencida — no otros 401 genéricos */
function isStrapiSessionExpiredUnauthorized(httpStatus, body) {
    if (httpStatus !== 401) return false;
    if (body?.error?.status === 401) return true;
    if (body?.error?.name === 'UnauthorizedError') return true;
    const msg = body?.error?.message;
    if (typeof msg === 'string' && /invalid or expired session token/i.test(msg)) return true;
    return false;
}

/**
 * Respuesta Strapi con JWT inválido/vencido: toast, quitar token, ir a /login.
 */
/** @returns {boolean} true si se activó redirección / toast por sesión expirada */
export function handleStrapiUnauthorized(httpStatus, body) {
    if (!isStrapiSessionExpiredUnauthorized(httpStatus, body)) return false;
    if (typeof window === 'undefined') return false;
    if (sessionStorage.getItem(GATE_KEY)) return true;
    sessionStorage.setItem(GATE_KEY, '1');
    window.localStorage.removeItem('jwt');
    const lang = window.localStorage.getItem('language') || 'de';
    showSessionToast(sessionExpiredMessage(lang));
    setTimeout(() => redirectToLogin('/login'), 80);
    return true;
}

export function parseJSON(resp) {
    return resp.json ? resp.json() : resp;
}

export function checkStatus(resp) {
    if (resp.status >= 200 && resp.status < 300) {
        return resp;
    }
    const httpStatus = resp.status;
    return parseJSON(resp).then((body) => {
        handleStrapiUnauthorized(httpStatus, body);
        throw body;
    });
}

/**
 * Sustituye `.then(r => r.json())` cuando hace falta detectar 401 en el cuerpo.
 * Si !response.ok, dispara sesión expirada (si aplica) y rechaza con el JSON.
 */
export function parseStrapiResponse(response) {
    return response.json().then((json) => {
        if (response.ok) return json;
        handleStrapiUnauthorized(response.status, json);
        throw json;
    });
}
